<template>
  <div class="reassurance-step-container">
    <div class="reassurance-step__title">
      {{ trans('guided_search.reassurance.title') }}
    </div>
    <div class="reassurance-step__description">
      <span>{{ trans('guided_search.reassurance.description.1') }}</span>
      <span>{{ trans('guided_search.reassurance.description.2') }}</span>
    </div>
    <div class="salesteam-card-content--persona">
      <media-image
        v-for="persona in personas"
        :key="persona.hash"
        :uuid="persona.hash"
        :alt="persona.alt"
        :width="56"
        :density="3"
      />
    </div>
    <trustpilot-widget width="250" />
    <button
      class="btn btn--primary btn--jumbo"
      @click="nextStep"
    >
      <span>
        {{ trans('guided_search.reassurance.start') }}
      </span>
    </button>
    <div class="reassurance-step__conditions">
      <!-- eslint-disable vue/no-v-html -->
      <p v-html="trans('guided_search.form.conditions.1', { link_cgu: $linkCgu, link_poc: $linkPoc, })" />
      <p v-html="trans('guided_search.form.conditions.2', { link_recaptcha: $linkRecaptcha, })" />
      <!-- eslint-enable vue/no-v-html -->
    </div>
  </div>
</template>

<script>
import MediaImage from '@components/MediaImage.vue';
import TrustpilotWidget from '@components-molecules/TrustpilotWidget.vue';
import { translationMixin } from '@elements/translation';

export default {
  name: 'Reassurance',
  components: { MediaImage, TrustpilotWidget },
  mixins: [ translationMixin ],
  data: () => ({
    personas: [
      {
        alt: 'Chloe',
        hash: '7cb83085-c0a4-4e04-9079-d6606184fba0',
      },
      {
        alt: 'Edouard',
        hash: '200265d9-fdbb-49a9-9cfa-3a90975e1109',
      },
      {
        alt: 'Martin',
        hash: '7203c5c8-13e1-41cc-b114-d898d50937d8',
      },
      {
        alt: 'Paul K',
        hash: 'ebd78b62-6bc4-4c66-a518-8e5a135da5bd',
      },
      {
        alt: 'Pauline',
        hash: '871cc45d-c40c-43bf-9d5f-4192180ed128',
      },
      {
        alt: 'Paul V',
        hash: '934a6318-5cc4-4592-9e15-860540550fef',
      },
      {
        alt: 'Paul P',
        hash: '3e55e4e8-bffd-4112-946b-d3f5fd54a7da',
      },
      {
        alt: 'Simon',
        hash: '45fd856a-d5b4-4d18-9a56-f4ed1d4221f3',
      },
      {
        alt: 'Victorien',
        hash: 'a46d0a00-2810-4eff-b223-80cd43420125',
      },
    ],
  }),
  mounted() {
    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'reassurance',
      funnel: 'support-contact-form',
      step: 'reassurance',
    });
  },
  methods: {
    nextStep() {
      this.$emit('next-step');
    },
  },
};
</script>
